import type { SVGProps } from "react"

// Vector assets exported from Figma (EGDE-197). The logo + heading chevron use
// the brand gradient (#F86F3E -> #FFB36E -> #E49E6E); the broken-route road is
// themeable via currentColor while its X badge keeps its own gradient.

export const LogoMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Logo">
      <circle
        id="Ellipse 90"
        cx="44"
        cy="44"
        r="41.4615"
        stroke="url(#paint0_linear_0_24)"
        strokeWidth="5.07692"
      />
      <path
        id="Union"
        d="M57.266 25.5887C59.2731 23.4003 63.2005 23.6026 64.9848 25.2586C66.9057 27.0366 66.7232 29.4738 65.892 31.6824C64.6143 35.0666 56.3129 45.3241 56.1254 47.2185C55.9387 49.1132 61.6346 53.4587 62.3344 55.5203C64.5239 61.9789 58.2338 66.0312 53.4594 61.8572C51.8625 60.4586 46.475 53.8287 45.1674 51.909C43.8598 49.9892 43.3835 48.7225 43.9613 46.2303C45.0461 41.5446 54.7116 29.7322 57.266 25.5887ZM29.0043 24.2C31.3814 23.658 33.2263 23.9819 35.0053 25.5877C36.683 27.1075 42.4202 33.8846 43.5658 35.7742C45.654 39.2289 45.0559 40.1763 43.2465 43.4891C41.0215 47.5668 34.7674 57.7689 31.9037 61.0262C27.9098 65.5649 21.4679 63.2043 22.0356 57.2625C22.4157 53.3164 30.4743 44.6947 32.1215 40.4295C32.6483 37.8461 26.0797 33.5051 25.6234 30.3797C25.2737 27.9736 26.3637 24.7969 29.0043 24.1941V24.2Z"
        fill="url(#paint1_linear_0_24)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_0_24"
        x1="3.60286"
        y1="80.1131"
        x2="112.538"
        y2="-17.2716"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopColor="#F86F3E" />
        <stop offset="0.68" stopColor="#FFB36E" />
        <stop offset="1" stopColor="#E49E6E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_0_24"
        x1="23.8218"
        y1="60.0071"
        x2="73.1496"
        y2="10.4652"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopColor="#F86F3E" />
        <stop offset="0.68" stopColor="#FFB36E" />
        <stop offset="1" stopColor="#E49E6E" />
      </linearGradient>
    </defs>
  </svg>
)

export const HeadingChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18.7636 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="Vector 1 (Stroke)"
      d="M10.4856 1.99715C11.8774 -0.0709341 14.6869 -0.622345 16.7608 0.765535C18.8348 2.15341 19.3877 4.95502 17.9959 7.0231L11.0397 17.3593C10.5029 18.1569 10.55 19.2102 11.1558 19.957L14.9663 24.6539C16.5372 26.5902 16.2365 29.4297 14.2947 30.9962C12.3529 32.5627 9.50531 32.2629 7.93442 30.3265L1.00648 21.787C-0.241115 20.2491 -0.33812 18.0801 0.767242 16.4376L10.4856 1.99715Z"
      fill="url(#paint0_linear_0_9)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_0_9"
        x1="18.7636"
        y1="16"
        x2="8.86019e-06"
        y2="16.0126"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB36E" />
        <stop offset="1" stopColor="#F86F3E" />
      </linearGradient>
    </defs>
  </svg>
)

export const NoResultsIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 78.3544 80.0005"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group">
      <path
        id="Vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.4023 19.1342L75.5263 27.258L66.0919 36.6921L57.9681 28.5683L49.8443 36.6921L40.4102 27.258L48.534 19.1342L40.4102 11.0104L49.8443 1.57617L57.9681 9.70004L66.0919 1.57617L75.5263 11.0104L67.4023 19.1342Z"
        fill="url(#paint0_linear_0_55)"
      />
      <path
        id="Vector_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.1534 19.1341L77.0067 27.9873L66.7255 38.2683L57.8723 29.4152L49.0193 38.2683L38.7383 27.9873L47.5913 19.1341L38.7383 10.2811L49.0193 0L57.8723 8.85314L66.7255 0L77.0067 10.2811L68.1534 19.1341ZM65.8687 21.4188L72.4373 27.9873L66.7255 33.6989L60.1571 27.1305C58.8953 25.8687 56.8495 25.8687 55.5877 27.1305L49.0193 33.6989L43.3076 27.9873L49.876 21.4188C51.1378 20.157 51.1378 18.1113 49.876 16.8495L43.3076 10.2811L49.0193 4.56938L55.5877 11.1378C56.8495 12.3996 58.8953 12.3996 60.1571 11.1378L66.7255 4.56938L72.4373 10.2811L65.8687 16.8495C64.6069 18.1113 64.6069 20.157 65.8687 21.4188Z"
        fill="currentColor"
      />
      <path
        id="Vector_3"
        d="M36.3463 15.3789C37.2385 15.3789 37.9618 16.1022 37.9618 16.9944C37.9618 17.8866 37.2385 18.6099 36.3463 18.6099H33.7874C32.8951 18.6099 32.1719 17.8866 32.1719 16.9944C32.1719 16.1022 32.8951 15.3789 33.7874 15.3789H36.3463Z"
        fill="currentColor"
      />
      <path
        id="Vector_4"
        d="M28.6708 15.3789C29.563 15.3789 30.2863 16.1022 30.2863 16.9944C30.2863 17.8866 29.563 18.6099 28.6708 18.6099H23.553C22.6608 18.6099 21.9375 17.8866 21.9375 16.9944C21.9375 16.1022 22.6608 15.3789 23.553 15.3789H28.6708Z"
        fill="currentColor"
      />
      <path
        id="Vector_5"
        d="M18.4347 15.3789C19.327 15.3789 20.0502 16.1022 20.0502 16.9944C20.0502 17.8866 19.327 18.6099 18.4347 18.6099H15.8758C15.0292 18.6099 14.2035 18.6929 13.4059 18.8506C12.5306 19.0238 11.6808 18.4547 11.5076 17.5794C11.3344 16.7041 11.9036 15.8542 12.7788 15.6811C13.7818 15.4826 14.8175 15.3789 15.8758 15.3789H18.4347Z"
        fill="currentColor"
      />
      <path
        id="Vector_6"
        d="M7.05106 18.0545C7.79242 17.5581 8.79581 17.7568 9.29217 18.4982C9.78854 19.2396 9.58991 20.243 8.84848 20.7394C7.46867 21.6631 6.28031 22.8515 5.35656 24.2313C4.86019 24.9727 3.8568 25.1714 3.11537 24.675C2.37401 24.1786 2.1753 23.1752 2.67167 22.4338C3.83047 20.703 5.32021 19.2132 7.05106 18.0545Z"
        fill="currentColor"
      />
      <path
        id="Vector_7"
        d="M0.30218 28.1597C0.475363 27.2844 1.3252 26.7153 2.20048 26.8885C3.07576 27.0616 3.64491 27.9115 3.47172 28.7868C3.31397 29.5843 3.23101 30.41 3.23101 31.2566C3.23101 32.1033 3.31397 32.929 3.47172 33.7266C3.64491 34.6019 3.07576 35.4517 2.20048 35.6249C1.3252 35.7981 0.475363 35.2288 0.30218 34.3536C0.103796 33.3506 0 32.315 0 31.2566C0 30.1983 0.103796 29.1626 0.30218 28.1597Z"
        fill="currentColor"
      />
      <path
        id="Vector_8"
        d="M2.67167 40.0808C2.1753 39.3394 2.37401 38.336 3.11537 37.8397C3.8568 37.3433 4.86019 37.5419 5.35656 38.2834C6.28031 39.6632 7.46867 40.8515 8.84848 41.7753C9.58991 42.2716 9.78854 43.275 9.29217 44.0165C8.79581 44.7578 7.79242 44.9565 7.05106 44.4602C5.32029 43.3014 3.83047 41.8116 2.67167 40.0808Z"
        fill="currentColor"
      />
      <path
        id="Vector_9"
        d="M12.7788 46.8334C11.9036 46.6602 11.3344 45.8104 11.5076 44.9351C11.6808 44.0598 12.5306 43.4907 13.4059 43.6638C14.2035 43.8216 15.0292 43.9046 15.8758 43.9046H18.0972C18.9893 43.9046 19.7127 44.6278 19.7127 45.5201C19.7127 46.4123 18.9893 47.1356 18.0972 47.1356H15.8758C14.8175 47.1356 13.7818 47.0318 12.7788 46.8334Z"
        fill="currentColor"
      />
      <path
        id="Vector_10"
        d="M60.3017 43.9043C61.0991 43.9043 61.8853 43.9562 62.6568 44.0568C63.5416 44.1722 64.1652 44.983 64.0498 45.8677C63.9344 46.7524 63.1236 47.376 62.2389 47.2607C61.6055 47.178 60.959 47.1353 60.3017 47.1353H58.0804C57.1881 47.1353 56.4648 46.412 56.4648 45.5198C56.4648 44.6276 57.1881 43.9043 58.0804 43.9043H60.3017Z"
        fill="currentColor"
      />
      <path
        id="Vector_11"
        d="M53.6402 43.9043C54.5323 43.9043 55.2557 44.6276 55.2557 45.5198C55.2557 46.412 54.5323 47.1353 53.6402 47.1353H49.1975C48.3053 47.1353 47.582 46.412 47.582 45.5198C47.582 44.6276 48.3053 43.9043 49.1975 43.9043H53.6402Z"
        fill="currentColor"
      />
      <path
        id="Vector_12"
        d="M44.7574 43.9043C45.6495 43.9043 46.3729 44.6276 46.3729 45.5198C46.3729 46.412 45.6495 47.1353 44.7574 47.1353H40.3147C39.4225 47.1353 38.6992 46.412 38.6992 45.5198C38.6992 44.6276 39.4225 43.9043 40.3147 43.9043H44.7574Z"
        fill="currentColor"
      />
      <path
        id="Vector_13"
        d="M35.8706 43.9043C36.7628 43.9043 37.4862 44.6276 37.4862 45.5198C37.4862 46.412 36.7628 47.1353 35.8706 47.1353H31.428C30.5358 47.1353 29.8125 46.412 29.8125 45.5198C29.8125 44.6276 30.5358 43.9043 31.428 43.9043H35.8706Z"
        fill="currentColor"
      />
      <path
        id="Vector_14"
        d="M26.98 43.9043C27.8722 43.9043 28.5955 44.6276 28.5955 45.5198C28.5955 46.412 27.8722 47.1353 26.98 47.1353H22.5374C21.6451 47.1353 20.9219 46.412 20.9219 45.5198C20.9219 44.6276 21.6451 43.9043 22.5374 43.9043H26.98Z"
        fill="currentColor"
      />
      <path
        id="Vector_15"
        d="M65.9737 48.2586C65.1495 47.9168 64.7584 46.9717 65.1002 46.1475C65.442 45.3234 66.3872 44.9323 67.2113 45.274C68.6794 45.8828 70.0491 46.6794 71.2906 47.6334C71.9982 48.1771 72.1306 49.1913 71.587 49.8987C71.0434 50.6062 70.0297 50.739 69.3218 50.1953C68.3017 49.4114 67.1774 48.7578 65.9737 48.2586Z"
        fill="currentColor"
      />
      <path
        id="Vector_16"
        d="M72.0571 52.932C71.5135 52.2245 71.6468 51.2103 72.3536 50.6666C73.0612 50.123 74.0757 50.2558 74.6193 50.9632C75.5733 52.2047 76.3697 53.5744 76.9788 55.0425C77.3204 55.8666 76.9295 56.8118 76.1048 57.1536C75.2809 57.4954 74.3358 57.1043 73.9941 56.2801C73.4949 55.0764 72.8414 53.9521 72.0571 52.932Z"
        fill="currentColor"
      />
      <path
        id="Vector_17"
        d="M74.9982 60.0141C74.8826 59.1294 75.5062 58.3186 76.3907 58.2032C77.276 58.0878 78.0862 58.7115 78.2017 59.5962C78.3027 60.3677 78.3544 61.1539 78.3544 61.9513C78.3544 62.7488 78.3027 63.535 78.2017 64.3066C78.0862 65.1913 77.276 65.815 76.3907 65.6996C75.5062 65.5841 74.8826 64.7734 74.9982 63.8887C75.0805 63.2553 75.1234 62.6088 75.1234 61.9513C75.1234 61.294 75.0805 60.6475 74.9982 60.0141Z"
        fill="currentColor"
      />
      <path
        id="Vector_18"
        d="M73.9941 67.6241C74.3358 66.7999 75.2809 66.4088 76.1048 66.7506C76.9295 67.0924 77.3204 68.0374 76.9788 68.8613C76.3697 70.3298 75.5733 71.6998 74.6193 72.9413C74.0757 73.6481 73.0612 73.7814 72.3536 73.2377C71.6468 72.6941 71.5135 71.6796 72.0571 70.972C72.8414 69.9518 73.4949 68.8274 73.9941 67.6241Z"
        fill="currentColor"
      />
      <path
        id="Vector_19"
        d="M69.3218 73.7077C70.0297 73.1641 71.0434 73.2966 71.587 74.0042C72.1306 74.7118 71.9982 75.7255 71.2906 76.2691C70.0491 77.2231 68.6794 78.0203 67.2113 78.6286C66.3872 78.9703 65.442 78.5793 65.1002 77.7554C64.7584 76.9315 65.1495 75.9864 65.9737 75.6439C67.1774 75.1456 68.3017 74.4913 69.3218 73.7077Z"
        fill="currentColor"
      />
      <path
        id="Vector_20"
        d="M62.24 76.6425C63.1247 76.5278 63.9354 77.1514 64.0509 78.0359C64.1663 78.9204 63.5426 79.7313 62.6579 79.8469C61.8863 79.947 61.1001 79.9995 60.3027 79.9995H57.8968C57.0046 79.9995 56.2812 79.2758 56.2812 78.384C56.2812 77.4915 57.0046 76.7685 57.8968 76.7685H60.3027C60.9601 76.7685 61.6066 76.7257 62.24 76.6425Z"
        fill="currentColor"
      />
      <path
        id="Vector_21"
        d="M53.0875 76.7695C53.9797 76.7695 54.703 77.4925 54.703 78.385C54.703 79.2768 53.9797 80.0005 53.0875 80.0005H48.2757C47.3834 80.0005 46.6602 79.2768 46.6602 78.385C46.6602 77.4925 47.3834 76.7695 48.2757 76.7695H53.0875Z"
        fill="currentColor"
      />
      <path
        id="Vector_22"
        d="M43.4586 76.7695C44.3509 76.7695 45.0741 77.4925 45.0741 78.385C45.0741 79.2768 44.3509 80.0005 43.4586 80.0005H38.6468C37.7546 80.0005 37.0312 79.2768 37.0312 78.385C37.0312 77.4925 37.7546 76.7695 38.6468 76.7695H43.4586Z"
        fill="currentColor"
      />
      <path
        id="Vector_23"
        d="M33.8414 76.7695C34.7336 76.7695 35.4569 77.4925 35.4569 78.385C35.4569 79.2768 34.7336 80.0005 33.8414 80.0005H29.0296C28.1373 80.0005 27.4141 79.2768 27.4141 78.385C27.4141 77.4925 28.1373 76.7695 29.0296 76.7695H33.8414Z"
        fill="currentColor"
      />
      <path
        id="Vector_24"
        d="M24.2167 76.7695C25.109 76.7695 25.8322 77.4925 25.8322 78.385C25.8322 79.2768 25.109 80.0005 24.2167 80.0005H21.8108C20.9186 80.0005 20.1953 79.2768 20.1953 78.385C20.1953 77.4925 20.9186 76.7695 21.8108 76.7695H24.2167Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_0_55"
        x1="75.5263"
        y1="19.1342"
        x2="40.4102"
        y2="19.1744"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB36E" />
        <stop offset="1" stopColor="#F86F3E" />
      </linearGradient>
    </defs>
  </svg>
)

/** Magnifying-glass icon shown inside the search field (start side). */
export const MagnifierIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9" cy="9" r="7" stroke="currentColor" strokeWidth="1.6" />
    <line
      x1="14.2"
      y1="14.2"
      x2="18.5"
      y2="18.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
)

/** Clear (X) icon shown at the end of the field once there is a query. */
export const ClearIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 5L5 15M5 5L15 15"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/** Small chevron used by the pagination prev/next buttons (points left). */
export const PagerChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 1L1.5 7L6.5 13"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
